const BLOG = 'blog';
const SOCIAL = 'social';
const PROFILE = 'profile';
const TUBE = 'tube';

export default {
  BLOG,
  SOCIAL,
  PROFILE,
  TUBE,
};
